module.exports = __webpack_public_path__ + "static/img/login-bg.2d4242db.png";